import { datadogRum } from '@datadog/browser-rum';
import type { NormalizedError, DefaultErrorJson } from './types';

const { VITE_STAGE } = import.meta.env;

export type DefaultErrorParams = {
  name?: string;
  message?: string;
  title?: string;
  error?: Error;
};
export class DefaultError<
  T extends DefaultErrorJson = DefaultErrorJson
> extends Error {
  title: string;
  keyword: string;
  response: {
    errors: NormalizedError[];
  };
  cause?: Error;
  name: string;

  constructor({ error, name, message, title }: DefaultErrorParams) {
    super(error?.message);

    /* istanbul ignore next -- @preserve */
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    this.name = name ?? DefaultError.name;
    this.title = title ?? 'Error';
    this.message = message ?? error?.message ?? 'Unexpected error';
    this.keyword = '';
    this.response = {
      errors: []
    };
    this.cause = error as Error;

    this.#logError();
  }

  static get name() {
    return 'DefaultError';
  }

  #logError() {
    console.error(
      `${this.stack} \n\n:: caused by :: \n\n ${this.cause?.stack}`
    );
    /* istanbul ignore next -- @preserve */
    if (VITE_STAGE !== 'test') {
      datadogRum.addError(this, {
        stack: this.stack
      });
    }
  }

  toJson(): T {
    const result: Record<string, unknown> = {};

    for (const key of Object.getOwnPropertyNames(this)) {
      if (['stack', 'cause', 'response'].includes(key) || key.startsWith('_'))
        continue;

      result[key] = this[key];
    }

    return result as T;
  }
}
